import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {HeroSectionHelper} from "../hero-section.helper";
import {BuilderSectionsInteractionService} from "../../../../../../builder-sections-interaction.service";

@Component({
    selector: 'db-b-type-hero-section',
    templateUrl: './b-type-hero-section.component.html',
    styleUrl: './b-type-hero-section.component.scss',
    standalone: false
})
export class BTypeHeroSectionComponent implements OnInit, OnChanges {
  @Input() logoTitle!: string;
  @Input() generationFinished!: boolean;
  @Input() generatedTexts: any;

  isMobile = false;
  isEcommerce = false;
  menuPages: any;
  styles: any;
  showHeaderSection: boolean = false;
  showHeaderBg: boolean = false;
  showBgImage: boolean = true;
  fadeInMenuElements: boolean[] = [];
  fadeInContentElements: boolean[] = [];
  activeTheme: string = this._builderInteractionsService.activeTheme.value.toLowerCase();
  openMenu = false;

  constructor(private _cdRef: ChangeDetectorRef,
              private _helper: HeroSectionHelper,
              private _builderInteractionsService: BuilderSectionsInteractionService) {}

  ngOnInit(): void {
    this.isMobile = this._helper.isMobile();
    this.menuPages = this._helper.getMenuPages();
    this.fadeInMenuElements = this._helper.createFadeArray(this.menuPages.length || 5);
    this.fadeInContentElements = this._helper.createFadeArray(3);
    this.styles = this._helper.getInitialStyles();
    this.setColor();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['generatedTexts'] && changes['generatedTexts'].currentValue) {
      this.isEcommerce = this._helper.isEcommerceType(changes['generatedTexts'].currentValue);
      setTimeout(() => {
        this.showBgImage = false;
        this._cdRef.markForCheck();
      }, 300);

      setTimeout(() => {
        this.showHeaderSection = true;
        this._cdRef.markForCheck();
      }, 700);
      setTimeout(() => {
        this.startFadeInSequence();
        this._cdRef.detectChanges();
      }, 1200);
    }
  }

  startFadeInSequence() {
    if (this.fadeInMenuElements.length) {
      this._helper.fadeInElements(this.fadeInMenuElements, this._cdRef, () => {
        this.fadeInHeaderButton();
      });
    }
    else {
      this.fadeInHeaderButton();
    }
  }

  fadeInHeaderButton(): void {
    setTimeout(() => {
      this.showHeaderBg = true;
      this._cdRef.markForCheck();
    }, 700);

    setTimeout(() => {
      this.fadeInContentSection();
    }, 1700);
  }

  fadeInContentSection(): void {
    if (this.fadeInContentElements.length) {
      this.fadeInContentElements.forEach((_, index) => {
        setTimeout(() => {
          this.fadeInContentElements[index] = true;
          this._cdRef.markForCheck();
        }, index * 200); // Delay each fade-out by 150ms
      });
    }
    else {
      this.showBgImage = false;
      this._cdRef.markForCheck();
    }
  }


  toggleMenu(): void {
    this.openMenu = this._helper.toggleMenu(this.openMenu);
  }

  setColor() {
    this._helper.getInitialStyles();
  }
}
